import { useMemo } from 'react'
import { ApplicationStep4 } from '../../../../../models/classes/ApplicationStep4.class'
import ReviewDocument from '../../../../../pages/application-coo/review-endorse/document'
import { shared_documents_list } from '../../../../../utils/shared/documents-list'

interface DocumentDetailsInterface {
  details: ApplicationStep4
}
const DocumentDetails = ({ ...props }: DocumentDetailsInterface) => {

  const mySubmittedDocuments = useMemo(() => {
    return props.details.file_items;
   }, [props.details.file_items])
  
    const documentList = useMemo(() => {
        return shared_documents_list.filter(item => mySubmittedDocuments.some(doc => doc.code === item.code));
    }, [mySubmittedDocuments])

  return (
    <div className='polymer-document-details'>
      <ReviewDocument document_list={documentList} file_items={mySubmittedDocuments} submitted_documents_code={[]} hasPadding={false} showTitle={false}/>
    </div>
  )
}

export default DocumentDetails